import { getDefaults, getTldLocaleFromRequest } from '@eventbrite/webapp-locales';
import { IncomingMessage } from 'http';

export function createDefaultLocaleInfo(req?: IncomingMessage) {
    const locale = req ? getTldLocaleFromRequest(req) : 'en_US';
    const defaults = getDefaults(locale) as unknown as Record<string, unknown>;
    // getServerSideProps breaks with undefined values, so we use nullish coalescing
    // to ensure empty strings for null/undefined while preserving existing non-empty values
    return {
        ...defaults,
        contact_us_path: defaults.contact_us_path ?? '',
        contact_us_url: defaults.contact_us_url ?? '',
        sales_contact_landing_page: defaults.sales_contact_landing_page ?? '',
        sales_contact_link_text: defaults.sales_contact_link_text ?? '',
        twitter_page: defaults.twitter_page ?? '',
        facebook_page: defaults.facebook_page ?? '',
        linked_in_page: defaults.linked_in_page ?? '',
        instagram_page: defaults.instagram_page ?? '',
        blog_url: defaults.blog_url ?? '',
        help_center_language: defaults.help_center_language ?? '',
    };
}
